import { loadedLibrary } from 'actions/global';

import { getRoomById, getRoom } from 'actions/room';
import { getRoomFilter, setRoomFilterQuery } from 'actions/filter';

import { withAsyncEnterLoader, withAsyncChangeLoader, withLoader } from 'util/routeHelper';
import { loadGoogleMapLibrary } from 'util/script';

import ReservationRoute from './Reservation';
import BookingRoute from './Booking';

export default store => ({
	path: 'room',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./home').default;
						cb(null, component);
					},
					'Rooms',
				),
			store,
			'ROOMS',
		),
		onChange: withAsyncChangeLoader(
			async (_, { location: { query } }, __, updateRatio) => {
				updateRatio(0.5);
				await store.dispatch(getRoom(query));
			},
			store,
			'CHANGE_ROOMS',
		),
		onEnter: withAsyncEnterLoader(
			async ({ location: { query } }, __, updateRatio) => {
				updateRatio(0.3);

				await store.dispatch(getRoomFilter());
				await [store.dispatch(getRoom(query)), store.dispatch(setRoomFilterQuery(query))];
				updateRatio(0.8);
			},
			store,
			'ENTER_ROOMS',
		),
	},
	childRoutes: [
		{
			path: ':id',
			indexRoute: {
				getComponent: withLoader(
					(nextState, cb) =>
						require.ensure(
							[],
							require => {
								const component = require('./component').default;
								cb(null, component);
							},
							'Room',
						),
					store,
					'ROOM',
				),
				onEnter: withAsyncEnterLoader(
					async ({ params: { id } }, __, updateRatio) => {
						updateRatio(0.3);

						await loadGoogleMapLibrary();
						store.dispatch(loadedLibrary('googleMap'));
						await [store.dispatch(getRoomById(id))];

						updateRatio(0.8);
					},
					store,
					'ENTER_ROOM_HOME',
				),
			},
			childRoutes: [ReservationRoute(store), BookingRoute(store)],
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/Room/index.js